import React__default from 'react';
import { Button } from '@sravni/react-design-system/lib/Button';
import { Link } from '@sravni/react-design-system/lib/Typography';
import { useAuthLoginLink } from '@sravni/react-utils';
import '../../Providers/CustomPropsProvider/src/CustomPropsProvider.js';
import { useCustomProps } from '../../Providers/CustomPropsProvider/hooks/useCustomProps.js';

const LoginButton = (props) => {
    const { oidcHandlerPrefix, fixedBackground, authBannerUrl } = useCustomProps();
    const authLoginLinkProps = useAuthLoginLink({ prefix: oidcHandlerPrefix, isNewWindow: true, bannerUrl: authBannerUrl });
    return (React__default.createElement(Link, { ...props, ...authLoginLinkProps },
        React__default.createElement(Button, { size: 36, variant: fixedBackground ? 'secondary' : 'outlined', color: "dark" }, "\u0412\u043E\u0439\u0442\u0438")));
};
LoginButton.displayName = 'LoginButton';

export { LoginButton };
//# sourceMappingURL=LoginButton.js.map
